"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledButton = void 0;

var styled_components_1 = __importDefault(require("styled-components"));

var textAlignKey = {
  start: 'flex-start',
  center: 'center',
  end: 'flex-end'
};
exports.StyledButton = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  color: ", ";\n  padding: 10px 20px;\n  outline: none;\n  transition: background-color 0.3s;\n  cursor: pointer;\n  align-items: center;\n  width: ", ";\n  display: flex;\n  text-decoration: none;\n  justify-content: ", ";\n  min-height: 42px;\n  border: none;\n  &:hover,\n  &:focus {\n    background-color: black;\n  }\n  ", "\n"], ["\n  background: ", ";\n  color: ", ";\n  padding: 10px 20px;\n  outline: none;\n  transition: background-color 0.3s;\n  cursor: pointer;\n  align-items: center;\n  width: ", ";\n  display: flex;\n  text-decoration: none;\n  justify-content: ", ";\n  min-height: 42px;\n  border: none;\n  &:hover,\n  &:focus {\n    background-color: black;\n  }\n  ", "\n"])), function (_a) {
  var submitButtonStyle = _a.submitButtonStyle;
  return (submitButtonStyle === null || submitButtonStyle === void 0 ? void 0 : submitButtonStyle.background) ? submitButtonStyle.background : '#2e2e2e';
}, function (_a) {
  var submitButtonStyle = _a.submitButtonStyle;
  return (submitButtonStyle === null || submitButtonStyle === void 0 ? void 0 : submitButtonStyle.color) ? submitButtonStyle.color : 'white';
}, function (_a) {
  var submitButtonStyle = _a.submitButtonStyle;
  return (submitButtonStyle === null || submitButtonStyle === void 0 ? void 0 : submitButtonStyle.width) ? submitButtonStyle.width : 'max-content';
}, function (_a) {
  var submitButtonStyle = _a.submitButtonStyle;
  return (submitButtonStyle === null || submitButtonStyle === void 0 ? void 0 : submitButtonStyle.textAlign) ? textAlignKey[submitButtonStyle.textAlign] : 'flex-start';
}, function (_a) {
  var submitButtonStyle = _a.submitButtonStyle;

  if (submitButtonStyle === null || submitButtonStyle === void 0 ? void 0 : submitButtonStyle.fontSize) {
    return "font-size: ".concat(submitButtonStyle.fontSize);
  } else {
    return '';
  }
});
var templateObject_1;